import { Breadcrumb as BreadcrumbUI } from "artisn-ui-react";
import { useRouter } from "next/router";
import React from "react";

import Styles from "./Breadcrumb.styles";
import { BreadcrumbProps as Props } from "./Breadcrumb.types";
import { CONSTANTS } from "config/constants";
import useTalkShop from "contexts/talkShop/talkShop/talkShop.context.hooks";

import ArrowRightBlackSVG from "../../../../public/assets/images/arrow-right-black.svg";

const { Item } = BreadcrumbUI;
const { WITH_TALK_SHOP } = CONSTANTS.FEATURE_FLAGS;

const Breadcrumb: React.FC<Props> = props => {
  const { items, className } = props;
  const router = useRouter();
  const { talkShopProvider } = useTalkShop();

  const renderSeparator = () => (
    <div className="Breadcrumb__icon">
      <ArrowRightBlackSVG />
    </div>
  );

  const onClick = (path: string) => {
    router.push(path);
  };

  if (talkShopProvider && WITH_TALK_SHOP) return null;

  return (
    <Styles className={`Breadcrumb ${className}`}>
      <BreadcrumbUI
        className="Breadcrumb__wrapper"
        separator={renderSeparator()}
      >
        {items.map((item, index) => {
          const { name, path } = item;
          return (
            <Item
              className="Breadcrumb__item"
              key={index}
              onClick={() => onClick(path)}
            >
              {name}
            </Item>
          );
        })}
      </BreadcrumbUI>
    </Styles>
  );
};

Breadcrumb.defaultProps = {
  className: ""
};

export default Breadcrumb;
